import { Box, Text } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const UniversalImporterContractsPage = () => {
  return (
    <ResponsivePage.Body>
      <Box justifyContent="center" alignItems="center" height="s400">
        <Text.Normal size="300" color="grey600">
          Import Contracts - Coming Soon
        </Text.Normal>
      </Box>
    </ResponsivePage.Body>
  )
}

export default UniversalImporterContractsPage
